import {ReviewProps} from '@/interfaces/models/review';

export type ClientProps = {
  color: string;
  comment: string | null;
  avatar: string | null;
  email: string | null;
  id: string;
  name: string;
  options: ClientOptions;
  phone: string;
  totalSpent: number;
  lastUnreadMessage: string;
  unreadMessageCount: number;
  unreadReviews: ReviewProps[];
  [key: string]: any;
};

export enum ClientOptions {
  NORMAL = 0,
  BANNED = 1,
  FAVORITE = 2
}
